/* Fit the real photo and controls to the available mobile viewport. No cart/price changes. */
(() => {
  const initialize = () => document.querySelectorAll('.tdt-ticket--photo-hero').forEach(root => {
    if (root.dataset.photoHeroReady) return;
    root.dataset.photoHeroReady = 'true';
    const gallery = root.querySelector('.opti2-gallery');
    const intro = root.querySelector('.erlebnis-show-intro');
    const rail = root.querySelector('.erlebnis-thumbnails');
    const sticky = root.querySelector('.tdt-ticket__sticky');
    if (!gallery || !intro || !rail || !sticky) return;
    const mobile = matchMedia('(max-width:899px)');
    let pending = false, viewportWidth = 0, stableHeight = 0;
    const fit = () => {
      pending = false;
      if (!mobile.matches || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
      const viewport = window.visualViewport;
      if (viewport && Math.abs(viewport.scale - 1) > 0.05) return;
      const measuredHeight = viewport ? viewport.height : window.innerHeight;
      const width = window.innerWidth;
      // Browser chrome can expand/collapse while scrolling. Keep the smallest
      // visible height for this width so the photograph does not repeatedly grow.
      if (Math.abs(width - viewportWidth) > 2 || !stableHeight) {
        viewportWidth = width; stableHeight = measuredHeight;
      } else stableHeight = Math.min(stableHeight, measuredHeight);
      const height = stableHeight;
      const galleryTop = gallery.getBoundingClientRect().top + window.scrollY;
      const stickyHeight = sticky.getBoundingClientRect().height;
      const introHeight = intro.getBoundingClientRect().height;
      // Intro overlaps the bottom of the photo; reserve thumbnails, CTA and a small gap.
      const photoHeight = Math.max(175, Math.min(660, height - galleryTop - stickyHeight - rail.offsetHeight - 30 - Math.max(0,introHeight - 148)));
      const value = Math.round(photoHeight) + 'px';
      if(root.style.getPropertyValue('--tdt-photo-height') !== value)root.style.setProperty('--tdt-photo-height',value);
    };
    const schedule = () => { if(!pending){pending=true;requestAnimationFrame(fit);} };
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      [intro,rail,sticky].forEach(el => observer.observe(el));
    }
    window.addEventListener('resize',schedule,{passive:true});
    viewportListen();
    function viewportListen(){window.visualViewport?.addEventListener('resize',schedule,{passive:true});}
    mobile.addEventListener('change',schedule);
    schedule();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
